module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1035-96eaa58633fefe401a6f6816c92dd868.png";